import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user_data: {
      nombre: '...',
      pic: 'static/dist/img/users/default.jpg'
    },
    aviso: 0
  },
  mutations: {
    set_user_name(state, obj) {
      state.user_data.nombre = obj.nombre;
      state.user_data.pic = 'static/dist/img/users/' + obj.pic;
      state.user_data.tipo = obj.tipo;
      state.user_data.menu_general= obj.menu_general
    },
  },
  actions: {


  }
})



// WEBPACK FOOTER //
// ./src/store/index.js